import React from 'react';
import { Button } from '@mui/material';
import {
  List,
  Datagrid,
  TextField,
  EmailField,
  DateField,
  Edit,
  SimpleForm,
  TextInput,
  SelectInput,
  Show,
  SimpleShowLayout,
  EditButton,
  ShowButton,
  DeleteButton,
  TopToolbar,
  ExportButton,
  NumberField,
  useDataProvider,
  useNotify,
  useRecordContext,
  useRefresh,
} from 'react-admin';

const WorkshopListActions = () => (
  <TopToolbar>
    <ExportButton />
  </TopToolbar>
);

const VerifyWorkshopField = () => {
  const record = useRecordContext();
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();

  if (!record || record.verificationStatus === 'APPROVED' || record.type === 'FREELANCE') {
    return null;
  }

  const handleApprove = async () => {
    try {
      await dataProvider.update('workshops', {
        id: `${record.id}/verify`,
        data: {},
        previousData: record,
      });
      notify('Workshop approved', { type: 'success' });
      refresh();
    } catch {
      notify('Workshop approval failed', { type: 'error' });
    }
  };

  return (
    <Button variant="outlined" size="small" onClick={handleApprove}>
      Approve
    </Button>
  );
};

export const WorkshopList = () => (
  <List actions={<WorkshopListActions />}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="address" />
      <TextField source="verificationStatus" />
      <TextField source="type" />
      <TextField source="pricingCategory" />
      <NumberField source="avgRating" />
      <DateField source="createdAt" />
      <VerifyWorkshopField />
      <ShowButton />
      <EditButton />
      <DeleteButton />
    </Datagrid>
  </List>
);

export const WorkshopEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="name" />
      <TextInput source="address" />
      <TextInput source="countryCode" />
      <TextInput source="county" />
      <TextInput source="city" />
      <TextInput source="phone" />
      <TextInput source="email" type="email" />
      <SelectInput
        source="type"
        choices={[
          { id: 'AUTHORIZED', name: 'Authorized' },
          { id: 'DEALERSHIP_SERVICE', name: 'Dealership Service' },
          { id: 'FREELANCE', name: 'Freelance' },
        ]}
      />
    </SimpleForm>
  </Edit>
);

export const WorkshopShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="address" />
      <TextField source="phone" />
      <EmailField source="email" />
      <TextField source="description" />
      <TextField source="verificationStatus" />
      <TextField source="type" />
      <TextField source="pricingCategory" />
      <NumberField source="avgRating" />
      <NumberField source="averageResponseTime" />
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
    </SimpleShowLayout>
  </Show>
);
